import { useGlobalSearchParams, usePathname } from 'expo-router';
import { ROUTES } from '@/shared/constants/routes';
import { useEffect, useState } from 'react';

export const useNylasOAuthReturn = () => {
  const { connected } = useGlobalSearchParams<{ connected: string }>();
  const pathname = usePathname();
  const [isReturningFromOAuth, setIsReturningFromOAuth] = useState(false);
  const [isOAuthSuccessful, setIsOAuthSuccessful] = useState(false);

  useEffect(() => {
    const isReturning =
      pathname === ROUTES.AVAILABILITY.path && connected !== undefined;
    const isSuccessful = connected === 'true';

    setIsReturningFromOAuth(isReturning);
    setIsOAuthSuccessful(isSuccessful);
  }, []);

  return {
    isReturningFromOAuth,
    isOAuthSuccessful,
  };
};
